import { render } from "./InputLabels.vue?vue&type=template&id=5fdd3021&scoped=true"
import script from "./InputLabels.vue?vue&type=script&lang=js"
export * from "./InputLabels.vue?vue&type=script&lang=js"

import "./InputLabels.vue?vue&type=style&index=0&id=5fdd3021&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdd3021"]])

export default __exports__